jQuery(function ($) {
    const $modal = $("#countrySelectModal");

    if (!$modal.hasClass("disable-auto-open")) {
        $modal.modal("show");
    }

    $(".country-selector-btn").on("click", function () {
        $modal.modal("show");
    });
});
